import React from 'react'
import {
  formatPrice,
  formatDiscount,
  formatPrecentage
} from '../../../helpers'

const ProductInfo = ({
  productPayload,
  account,
  handleGoBack,
  handleAddToCart
}) => {
  if (!productPayload) return null

  const outOfStock = productPayload.has_stock === false || productPayload.has_stock === 0 || productPayload.has_stock === '0' || productPayload.has_stock === 'false' || productPayload.hasStock === false

  return (
    <div className="cover-detail">
      <div style={{ position: 'relative' }}>
        <img
          src={process.env.REACT_APP_IMAGE_URL + productPayload.image}
          alt={productPayload.name}
        />
        {outOfStock && (
          <span style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            backgroundColor: '#6c757d',
            color: '#ffffff',
            padding: '6px 12px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.5px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
            zIndex: 2
          }}>
            Stok Habis
          </span>
        )}
      </div>
      <div className="content-detail">
        <h2 className="judul">{productPayload.name}</h2>
        <div className="harga">
          <p>Harga Satuan</p>
          <div className="cover-harga">
            <p className="diskon">{formatPrecentage(account, productPayload.discount)}%</p>
            <p className="harga-diskon">{formatPrice(productPayload.price, 'Rp.')}</p>
            <p className="harga-produk">
              {
                formatDiscount(
                  productPayload.price,
                  formatPrecentage(account, productPayload.discount),
                  'Rp.'
                )
              }
            </p>
          </div>
        </div>
        <div className="produsen">
          <p className="label-produsen">Produsen</p>
          <p className="nama-produsen">{productPayload.producer?.name}</p>
        </div>
        <div className="jumlah">
          <p className="label-jumlah">Pembelian</p>
          <p className="volume-jumlah">Kelipatan {productPayload.amount}</p>
        </div>
        <div className="berat">
          <p className="label-berat">Berat</p>
          <p className="volume-berat">{productPayload.weight}</p>
        </div>
        <div className="btn-cover">
          <a onClick={handleGoBack} className="btn-kembali">Kembali</a>
          {outOfStock ? (
            <a className="btn-keranjang btn-keranjang-disabled">Stok Habis</a>
          ) : (
            <a onClick={handleAddToCart} className="btn-keranjang">Masukan keranjang</a>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductInfo
